import script from "./Principal.vue?vue&type=script&setup=true&lang=js"
export * from "./Principal.vue?vue&type=script&setup=true&lang=js"

import "./Principal.vue?vue&type=style&index=0&id=2ba1821f&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba1821f"]])

export default __exports__